module.exports = __webpack_public_path__ + "static/media/google.cb374293.png";